import { Box, Button } from "@mui/material";
import { useState } from "react";

import { useCan } from "../auth/permissions.js";
import { SectionHeader } from "../components/SectionHeader.js";
import { ServerEventHistory } from "./server-status/ServerEventHistory.js";
import { AddServerModal, ServerList } from "./server-status/ServerList.js";

/**
 * Server Status page. Two-column layout (70/30) — the user's monitored
 * servers fill the left side, the right side is a paginated 20-day
 * history of up/down transitions (`server_events` table).
 */
export function ServerStatusPage(): JSX.Element {
  const canManage = useCan("server:manage");
  const [addOpen, setAddOpen] = useState(false);

  return (
    <>
      <SectionHeader
        title="Servers"
        right={
          canManage ? (
            <Button variant="contained" size="small" onClick={() => setAddOpen(true)}>
              Add server
            </Button>
          ) : null
        }
      />

      <Box
        sx={{ display: "grid", gap: 2, gridTemplateColumns: { lg: "7fr 3fr" } }}
        data-testid="server-status-grid"
      >
        <Box
          component="section"
          aria-label="Monitored servers"
          data-testid="server-status-list"
        >
          <ServerList
            {...(canManage ? { onAdd: () => setAddOpen(true) } : {})}
          />
        </Box>
        <Box data-testid="server-status-history">
          <ServerEventHistory />
        </Box>
      </Box>

      {addOpen && <AddServerModal onClose={() => setAddOpen(false)} />}
    </>
  );
}
